import { render, staticRenderFns } from "./SafetyContact.vue?vue&type=template&id=3b648867"
import script from "./SafetyContact.vue?vue&type=script&lang=js"
export * from "./SafetyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports